import AppDetailsPanel from "components/Application/AppDetailsPanel";
import ContainerWrapper from "components/Container/ContainerWrapper";
import PageTitleWrapper from "components/PageTitleWrapper";
import { applicationDetails } from "dto/appDto";
import { AuthState } from "dto/authDto";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import { getApplicationById } from "services/appsService";
import { getAllUser } from "services/userServices";
import { selectAuth } from "slices/authSlice";
import { setUserData } from "slices/userSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { Log } from "utilities/helper";
import PageHeader from "../assignedApplications/components/PageHeader";
import AssignedApplicationListTable from "./components/AssignedApplicationListTable";

function AssignedApplications() {
  const [searchparams] = useSearchParams();

  let auth = useAppSelector<AuthState>(selectAuth);
  const dispatch = useAppDispatch();

  const [totalUserCount, setTotalUserCount] = useState<number>(0);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [selectedApp, setSelectedApp] = useState<null | applicationDetails>();
  const [searchString, setSearchString] = useState("");

  const [updateData, setUpdateData] = useState(false);

  useEffect(() => {
    var appid = "";
    if (searchparams.has("appid")) {
      appid = searchparams.get("appid")!;
    }

    getAllUser(
      auth.authToken,
      appid,
      searchString,
      false,
      page + 1,
      limit
    ).then((response) => {
      if (response[0]) {
        var result = response[0];
        if (result.success) {
          dispatch(setUserData(result.data));
          setTotalUserCount(result.totalCount);
        } else {
          dispatch(setUserData([]));
          Log(result.message);
        }
      } else {
        dispatch(setUserData([]));
        var error = response[1];
        Log(error.message);
      }
    });

    if (appid !== "") {
      var id = searchparams.get("appid") as string;
      getApplicationById(auth.authToken, id).then((response) => {
        if (response[0]) {
          var result = response[0];
          if (result.success) {
            setSelectedApp(result.data);
          } else {
            setSelectedApp(null);
            Log(result.message);
          }
        } else {
          setSelectedApp(null);
          var error = response[1];
          Log(error.message);
        }
      });

      
    } else {
      setSelectedApp(null);
    }
  }, [searchparams, page, limit, auth.authToken, searchString]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateNotificationUserList = () => {
    setUpdateData(true);
  };

  return (
    <>
      <Helmet>
        <title>My Applications</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper>

      <ContainerWrapper>
        {selectedApp ? (
          <AppDetailsPanel app={selectedApp} showGrantAccessButton={true} updateNotificationUserList={updateNotificationUserList}/>
        ) : null}
        <AssignedApplicationListTable
          app={selectedApp} updateData={updateData}
        />
      </ContainerWrapper>
    </>
  );
}

export default AssignedApplications;
